import { Menu, CalendarDays, Layers, HardDrive, UserPen, Sun, Moon, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useVault } from "@/context/VaultContext";
import { StarLogo } from "./StarLogo";
import { GlobalSearch } from "./GlobalSearch";

function HBtn({ icon: Icon, label, onClick, testid }) {
  return (
    <Button variant="ghost" size="sm" onClick={onClick} data-testid={testid} title={label} aria-label={label} className="h-9 gap-2 px-2 sm:px-2.5">
      <Icon className="h-4 w-4" />
      <span className="hidden xl:inline">{label}</span>
    </Button>
  );
}

export function Header({ onMenu, searchRef }) {
  const { setDialog, theme, toggleTheme, lock, setView, setNoteId } = useVault();
  return (
    <header className="sticky top-0 z-30 w-full max-w-[100vw] border-b bg-background/90 backdrop-blur-md px-3 lg:px-5 py-2 md:py-0 md:h-14 flex flex-wrap md:flex-nowrap items-center gap-x-1 gap-y-2" data-testid="app-header">
      <Button variant="ghost" size="icon" className="lg:hidden h-9 w-9 shrink-0" onClick={onMenu} data-testid="sidebar-open-button" aria-label="Open folders">
        <Menu className="h-5 w-5" />
      </Button>
      <div className="flex items-center gap-2 min-w-0 shrink" data-testid="brand">
        <StarLogo className="h-6 w-6 shrink-0" />
        <span className="hidden min-[420px]:inline font-heading font-bold tracking-tight text-lg">StarVault</span>
        <span className="hidden lg:inline text-sm text-muted-foreground truncate">• by Sammy Star</span>
      </div>
      <GlobalSearch ref={searchRef} />
      <nav className="ml-auto flex shrink-0 items-center" data-testid="header-actions">
        <HBtn icon={CalendarDays} label="Calendar" onClick={() => { setNoteId(null); setView("calendar"); }} testid="open-calendar-button" />
        <HBtn icon={Layers} label="Merge & Compile" onClick={() => setDialog("merge")} testid="open-merge-button" />
        <HBtn icon={HardDrive} label="Backup & Sync" onClick={() => setDialog("backup")} testid="open-backup-button" />
        <HBtn icon={UserPen} label="Creator Studio" onClick={() => setDialog("profile")} testid="open-profile-button" />
        <HBtn icon={theme === "dark" ? Sun : Moon} label={theme === "dark" ? "Light" : "Dark"} onClick={toggleTheme} testid="theme-toggle-button" />
        <HBtn icon={Lock} label="Panic Lock" onClick={lock} testid="lock-now-button" />
      </nav>
    </header>
  );
}
